import renderSomethingWentWrong from './renderSomethingWentWrong';

export default renderSomethingWentWrong;
